<div *ngIf="textInputForm" class="text-input-search" [formGroup]="textInputForm">
  <mat-icon class="text-input-search__icon" matPrefix [svgIcon]="field.icon" role="presentation"></mat-icon>
  <input
    [formControlName]="field.name"
    class="text-input-search__input"
    type="text"
    [placeholder]="field.placeholder"
    [attr.aria-label]="field.ariaLabel"
    [style.width]="(field.percentageWidth ? field.percentageWidth : '80') + '%'"
  />
  <button
    type="button"
    *ngIf="!!value"
    mat-icon-button
    [attr.aria-label]="'Suppression du filtre ' + field.ariaLabel | lowercase | upperfirst"
    matSuffix
    (click)="clearValue($event)"
  >
    <mat-icon class="text-input-search__icon--delete" svgIcon="cross" role="presentation"></mat-icon>
  </button>
</div>
